// extracted by mini-css-extract-plugin
export default {"root":"ContactsButtonList_root__IXOV1","rootTypeListItem":"ContactsButtonList_rootTypeListItem__QiSh4","rootTypeAboutOlymp":"ContactsButtonList_rootTypeAboutOlymp__2jfP4"};